import { useCallback, useEffect, useState } from "react";
import api from "../../../../Component/axios";

export const useSugerencia = (activo) => {
  const [sugerencias, setSugerencias] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isSlowLoading, setIsSlowLoading] = useState(false);

  const createSugerencia = async (values) => {
    const token = localStorage.getItem("@Token");
    setIsSaving(true);
    try {
      await api.post("api/catalogo/sugerencia_empaque/create/", values, {
        headers: {
          Authorization: "Token " + token,
        },
      });
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setIsSaving(false);
    }
  };

  const deleteSugerencia = async (sugerencia_id) => {
    const token = localStorage.getItem("@Token");
    try {
      await api.delete(
        `api/catalogo/sugerencia_empaque/delete/${sugerencia_id}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        },
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const updateSugerencia = async (sugerencia_id, data) => {
    const token = localStorage.getItem("@Token");
    setIsSaving(true);
    try {
      await api.put(
        `api/catalogo/sugerencia_empaque/update/${sugerencia_id}/`,
        data,
        {
          headers: {
            Authorization: "Token " + token,
          },
        },
      );
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setIsSaving(false);
    }
  };

  const getSugerenciaList = useCallback(async () => {
    const token = localStorage.getItem("@Token");
    setIsLoading(true);
    setIsSlowLoading(false);

    const timeout = setTimeout(() => {
      setIsSlowLoading(true);
    }, 5000); // 5 segundos
    try {
      const response = await api.get("api/catalogo/sugerencia_empaque/list/", {
        params: { activo },
        headers: {
          Authorization: "Token " + token,
        },
      });
      setSugerencias(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      clearTimeout(timeout);
      setIsLoading(false);
      setIsSlowLoading(false);
    }
  }, [activo]);

  useEffect(() => {
    getSugerenciaList();
  }, [getSugerenciaList]);

  return {
    sugerencias,
    isLoading,
    isSlowLoading,
    isSaving,
    getSugerenciaList,
    createSugerencia,
    deleteSugerencia,
    updateSugerencia,
  };
};
